import { useRef } from 'react';
import type { EtcTicketSummary } from '#/components/ui/tickets/etc/model';

export type ChargeFailDialogConfirmValue = { afterDays: number };

export type ChargeFailDialogRef = {
  confirm: (
    ticket: EtcTicketSummary,
    amount: number,
  ) => Promise<ChargeFailDialogConfirmValue | undefined>;
  days: number | undefined;
};

export const useChargeFailDialog = () => {
  const modalRef = useRef<ChargeFailDialogRef>(null);
  const open = (ticket: EtcTicketSummary, amount: number) =>
    modalRef.current?.confirm(ticket, amount);
  return { props: { modalRef }, open };
};
